export enum InteractivityEventTypeValue {
  Click = 'click', // applies to items
  Hover = 'hover', // applies to items
  Leave = 'leave', // applies to items
  VisibleAfterAnimation = 'visibleAfterAnimation', // applies to items
  Visible = 'visible', // applies to items
  Hidden = 'hidden', // applies to items
  SlideEntering = 'slideEntering', // applies to items
  SlideEntered = 'slideEntered', // applies to items
  SlideExiting = 'slideExiting', // applies to items
}
